import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  private eventSource = new Subject<void>();
  event$ = this.eventSource.asObservable();

  triggerEvent() {
    this.eventSource.next();
  }
}
